<div class="container">
    <div *ngIf="showDisplay" class="row">
        <div class="row-title">{{'dashboard.display' | stringLiterals}}</div>
        <div class="control">
            <kendo-dropdownlist [popupSettings]="{appendTo: 'component'}" [filterable]="false" [data]="displayList"
                [textField]="'value'" [valueField]="'id'" [value]="selectedDisplay" [disabled]="config.fixDisplay"
                (valueChange)="onDisplayChange($event)">
            </kendo-dropdownlist>
        </div>
    </div>
    <div *ngIf="!config.default" class="row">
        <div class="row-title">{{'dashboard.parameter_value' | stringLiterals}} <span class="required-field">*</span>
        </div>
        <div class="control">
            <kendo-dropdownlist [popupSettings]="{appendTo: 'component'}" [filterable]="false"
                [data]="parameterValueList" [textField]="'value'" [valueField]="'id'" [value]="selectedParameterValue"
                (valueChange)="onParameterValueChange($event)">
            </kendo-dropdownlist>
        </div>
    </div>
    <div *ngIf="!config.default && showDataType" class="row">
        <div class="row-title">{{'dashboard.data_type' | stringLiterals}}</div>
        <div class="control">
            <kendo-dropdownlist [popupSettings]="{appendTo: 'component'}" [filterable]="false" [data]="dataTypeList"
                [textField]="'value'" [valueField]="'id'" [value]="selectedDataType" [disabled]="config.fixDataType">
            </kendo-dropdownlist>
        </div>
    </div>
    <div *ngIf="!config.default && isShowDisplayAs" class="row">
        <div class="row-title">{{'dashboard.display_as' | stringLiterals}}</div>
        <div class="control">
            <kendo-dropdownlist [popupSettings]="{appendTo: 'component'}" [filterable]="false" [data]="displayAsList"
                [textField]="'value'" [valueField]="'id'" [value]="selectedDisplayAs"
                (valueChange)="onDisplayAsChange($event)">
            </kendo-dropdownlist>
        </div>
    </div>
</div>